import { Grid } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import LineInputDate from '../../../../../components/Inputs/LineInputDate'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText'
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect'
import ContraintLayout from '../../../../../components/Layouts/ConstraintLayout'
import ModalBase from '../../../../../components/Modals/ModalBase'
import DisplayText from '../../../../../components/Texts/DisplayText'
import {constrainst_basic_information as constrainst} from  '../../constraints'
import { onValidateForm } from '../../../../../shared/utility'
import {formData } from './data'
import SwitchButton from '../../../../../components/Buttons/SwitchButton'
import moment from 'moment'
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton'
import {request_update_patient} from '../../requests'

const EditBasicInfoModal = props => {

    const {initData, patientID, open, onClose, onUpdatePatient} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [valid, setValid] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [hasInsurance, setHasInsurace] = useState(false)
    const [firstTime, setFirstTime] = useState(false)

    useEffect(() => {
        if(!initData) return
        let temp = {...form}
        Object.keys(form).forEach( item =>{
            let newValue = initData[item] 
            if(newValue !== null && newValue !== undefined){
                if(item === 'interview_date'){
                    if(moment(newValue).isValid()){
                        newValue = moment(newValue).format('YYYY-MM-DD')
                    }
                }
                temp[item].value = newValue
                temp[item].isValid = true
                temp[item].isVisited = true
            }
        })
        if(initData.first_time) setFirstTime(true)
        if(initData.has_insurance) setHasInsurace(true)
        setValid(onValidateForm(temp))
        setForm(temp)

    }, [initData, open])


    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        setValid(onValidateForm(temp))
        setForm(temp)
    }

    const onEdit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            return
        }
        
        let data2send = {}
        Object.keys(form).forEach(item => {
            if((initData[item] !== form[item].value) && form[item].isValid){
                data2send = {...data2send, [item]: form[item].value}
            }
        })
        data2send = {...data2send,
            has_insurance: hasInsurance ? 1 : 0,
            first_time: firstTime ? 1 : 0,
        }
        setLoading(true)
        try {
            const newPatient = await request_update_patient(patientID, data2send)
            setLoading(false)
            onUpdatePatient(newPatient)
            onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
            setLoading(false)
        }

    }


    let publicInsuranceContent = null
    let policyValueContent = null
    if(hasInsurance){
      publicInsuranceContent = (
        <Grid item xs={12}>
            <LineInputText 
                data={form.insurance_carrier}
                onChange={onInputChange}/>
        </Grid> 
      )
      policyValueContent = (
        <Grid item xs={12}>
            <LineInputText 
                data={form.policy_value}
                onChange={onInputChange}/>
        </Grid> 
      )
    }
    

    return(
        <ModalBase open={open} onClose={onClose}>
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Información principal</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={4}>
                            <ContraintLayout constrainst={constrainst.name}>
                                <LineInputText 
                                data={form.name}
                                onChange={onInputChange}
                                />
                            </ContraintLayout>
                            <ContraintLayout constrainst={constrainst.doctor_id}>
                                <LineInputText 
                                data={form.doctor}
                                onChange={onInputChange}
                                />
                            </ContraintLayout>
                            <ContraintLayout constrainst={constrainst.age}>
                                <LineInputText 
                                data={form.age}
                                onChange={onInputChange}
                                />
                            </ContraintLayout>
                            <ContraintLayout constrainst={constrainst.gender_id}>
                                <LineInputSelect 
                                data={form.gender_id}
                                onChange={onInputChange}
                                />
                            </ContraintLayout>
                            <ContraintLayout constrainst={constrainst.state_id}>
                                <LineInputSelect 
                                data={form.state_id}
                                onChange={onInputChange}
                                />
                            </ContraintLayout>
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.city}
                                onChange={onInputChange}
                                />
                            </Grid> 
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.suburb}
                                onChange={onInputChange}
                                />
                            </Grid> 
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.zip_code}
                                onChange={onInputChange}
                                />
                            </Grid> 
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <DisplayText variant='subtitle1'>Información de entrevista</DisplayText>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={4}>
                                    <Grid item xs={12} md={6}>
                                        <LineInputDate 
                                        data={form.interview_date}
                                        onChange={onInputChange}
                                        />
                                    </Grid> 
                                    <Grid item xs={12} md={6}>
                                        <LineInputText 
                                        data={form.phone}
                                        onChange={onInputChange}
                                        />
                                    </Grid> 
                                    <Grid item xs={12}>
                                        <LineInputText 
                                        data={form.address}
                                        onChange={onInputChange}
                                        />
                                    </Grid> 
                                    </Grid>
                                </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify='flex-end'>
                                <Grid item>
                                    <SwitchButton 
                                    id='firstTime' status={firstTime} 
                                    onChange={(id, status) => setFirstTime(status)}
                                    message='¿Es la primera vez que el paciente ha tomado éste examen?'/>
                                </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify='flex-end'>
                                <Grid item>
                                    <SwitchButton 
                                    id='hasInsurance' status={hasInsurance} 
                                    onChange={(id, status) => setHasInsurace(status)}
                                    message='¿Es paciente de aseguradora?'/>
                                </Grid>
                                </Grid>
                            </Grid>
                            {publicInsuranceContent}
                            {policyValueContent}
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton error={error} loading={loading} onSubmit={onEdit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default EditBasicInfoModal